import { render } from "./DashboardView.vue?vue&type=template&id=2bd3dc18"
import script from "./DashboardView.vue?vue&type=script&lang=js"
export * from "./DashboardView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__